import axios from 'axios';
import store, { history } from '../store';

export const TEAM_JOINED = 'TEAM_JOINED';

const joinTeam = teamId => (
  (dispatch) => {
    return axios.post(`/api/teams/${teamId}`)
      .then(() => {
        dispatch({
          type: TEAM_JOINED,
          teamId,
        });

        history.push(`/signup/teams/${teamId}`);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      });
  }
);

export default joinTeam;
